<template>
  <div class="admin-shops-index">
    <div class="wrapper">
      <header-component></header-component>
      <admin-nav-menu></admin-nav-menu>
      <div>
        <md-table>
          <md-table-header>
            <md-table-row>
              <md-table-head>店舗名</md-table-head>
              <md-table-head>都道府県</md-table-head>
              <md-table-head>最寄駅</md-table-head>
              <md-table-head>閉店</md-table-head>
            </md-table-row>
          </md-table-header>
          <md-table-body>
            <md-table-row v-for="shop in shops" :key="shop.id">
              <md-table-cell><router-link :to="{ name: 'AdminShopsEdit', params: { id: shop.doc_id }}">{{ shop.name }}</router-link></md-table-cell>
              <md-table-cell>{{shop.prefecture}}</md-table-cell>
              <md-table-cell>{{shop.station}}</md-table-cell>
              <md-table-cell>{{shop.closed}}</md-table-cell>
            </md-table-row>
          </md-table-body>
          <infinite-loading @infinite="infiniteHandler">
            <span class="hoge" slot="no-more">
              これ以上居酒屋データがありません
            </span>
          </infinite-loading>
        </md-table>
      </div>
    </div>
  </div>
</template>

<script>
import firebaseApp from '../../../firebaseApp'
import InfiniteLoading from 'vue-infinite-loading'
import HeaderComponent from '../../Header.vue'
import AdminNavMenu from '../AdminNavMenu.vue'

const db = firebaseApp.firestore()
const PER_COUNT = 25
let next = db.collection('shops').limit(PER_COUNT)

let data = {
  shops: []
}

export default {
  name: 'admin-shops-index',
  components: {
    InfiniteLoading,
    HeaderComponent,
    AdminNavMenu
  },
  data: function () {
    return data
  },
  methods: {
    infiniteHandler ($state) {
      next.get().then(function (documentSnapshots) {
        if (documentSnapshots.docs.length === 0) {
          $state.complete()
        }
        documentSnapshots.forEach(function (snapShot) {
          data.shops.push(Object.assign(snapShot.data(), {doc_id: snapShot.id}))
        })
        var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1]
        next = db.collection('shops').startAfter(lastVisible).limit(PER_COUNT)
      }).then(function () {
        $state.loaded()
      })
    }
  },
  mounted () {
    this.$material.setCurrentTheme('admin')
  },
  destroyed () {
    this.$material.setCurrentTheme('default')
  }
}
</script>

<style scoped>

ul {
  list-style: none;
}

header {
  margin-left: -45px;
}

.wrapper {
  width: 960px;
  height: auto;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Shops/Index.vue